export default __webpack_public_path__ + "static/media/ArcSight ESM Advanced Analyst.d428fcb4.png";